export default __webpack_public_path__ + "static/favicon-09e6ecc54baef7be75cb94e63f8f230a.ico";